/* import __COLOCATED_TEMPLATE__ from './d-modal-cancel.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./d-modal-cancel.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());